import { atom, useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { getBagCount } from '../services/backpack';
import type { BagRedDotRes } from '@/types/api/backpack/bag-red-dot';
/**
 * 背包红点数量的原子状态
 */
export const bagCountAtom = atom<number>(0);

/**
 * 只读背包红点数量
 */
export const useBagCountValue = () => {
  return useAtomValue(bagCountAtom);
};

/**
 * 背包红点数量管理 Hook（包含 API 调用）
 */
export const useBagCountManager = () => {
  const [bagCount, setBagCount] = useAtom(bagCountAtom);

  const updateBagCount = useCallback(async () => {
    try {
      const res: BagRedDotRes = await getBagCount({});
      setBagCount(res?.bag_count ?? 0);
      return res?.bag_count ?? 0;
    } catch (error) {
      console.error('Failed to update bag count:', error);
      throw error;
    }
  }, [setBagCount]);

  return {
    bagCount,
    setBagCount,
    updateBagCount,
  };
};
